import { render } from "./ws-grid.vue?vue&type=template&id=53d990c6"
import script from "./ws-grid.vue?vue&type=script&lang=js"
export * from "./ws-grid.vue?vue&type=script&lang=js"

import "./ws-grid.vue?vue&type=style&index=0&id=53d990c6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__